import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * @module graphql-fetch
 * @ignore
 * __VERSION_HERE__
 * */

var OPERATION_METHODS = {
  mutation: 'POST',
  query: 'GET'
};
export var createHeaders = function createHeaders(_ref) {
  var visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    token = _ref.token,
    appId = _ref.appId,
    callerId = _ref.callerId,
    cloudStack = _ref.cloudStack,
    wafHeader = _ref.wafHeader;
  return _objectSpread(_objectSpread(_objectSpread({
    accept: 'application/json',
    'Content-Type': 'application/json; charset=UTF-8',
    appid: appId,
    'nike-api-caller-id': callerId || appId
  }, wafHeader ? {
    'X-Nike-WAF': wafHeader
  } : {}), cloudStack ? {
    cloud_stack: cloudStack
  } : {}), token ? {
    Authorization: "Bearer ".concat(token)
  } : {
    'X-Nike-VisitId': visitId,
    'X-Nike-VisitorId': visitorId
  });
};
export var defaultArgs = {
  operationType: 'query',
  operationName: undefined,
  token: undefined,
  visitId: undefined,
  visitorId: undefined,
  hash: undefined,
  variables: undefined,
  appName: undefined,
  appId: undefined,
  url: 'https://api.nike.com/cic/grand/v1/graphql',
  cloudStack: undefined,
  method: undefined,
  mutation: undefined,
  query: undefined,
  fetchOptions: {}
};
export var noHashAndOperationError = new Error('graphql-fetch requires a hash, mutation or query');

/**
 * a thin wrapper around isomorphic-fetch with some best practices and requirements for Nike Digital baked in
 *
 * @param {object} params - named parameters
 * @param {Function} params.fetchClient - a fetch implementation such as isomorphic-fetch or a wrapped fetch function
 * @param {string} [params.operationType='query'] - type of graphql operation - query by default, mutation
 * @param {string} params.operationName - a human readable enum for hash
 * @param {string} params.versionedQuery - the version of the persisted query
 * @param {string} params.token - user auth token
 * @param {string} params.visitId - user visitor id
 * @param {string} params.visitorId - user visit id
 * @param {string} params.hash - a whitelisted hash from GRAND server
 * @param {string} params.variables - variables to use with a persisted query
 * @param {string} params.appId - app id for downstream services to identify the requesting app
 * @param {string} params.callerId - caller id for downstream services to identify the requesting app
 * @param {string} params.wafHeader - WAF header to use in queries
 * @param {string} params.cloudStack - cloudStack to use specific cluster
 * @param {string} params.url - url to use, defaults to https://api.nike.com/cic/grand/v1/graphql
 * @param {string} params.method - method property for fetch options
 * @param {object} [params.fetchOptions={}] - options to pass into args for fetch
 * @returns {Promise} resolves or rejects from a fetch resolution
 */
export default function graphqlFetch() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultArgs,
    fetchClient = _ref2.fetchClient,
    _ref2$operationType = _ref2.operationType,
    operationType = _ref2$operationType === void 0 ? 'query' : _ref2$operationType,
    operationName = _ref2.operationName,
    versionedQuery = _ref2.versionedQuery,
    token = _ref2.token,
    visitId = _ref2.visitId,
    visitorId = _ref2.visitorId,
    hash = _ref2.hash,
    variables = _ref2.variables,
    appId = _ref2.appId,
    callerId = _ref2.callerId,
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? process.env.GRAND_URL || 'https://api.nike.com/cic/grand/v1/graphql' : _ref2$url,
    cloudStack = _ref2.cloudStack,
    method = _ref2.method,
    _ref2$fetchOptions = _ref2.fetchOptions,
    fetchOptions = _ref2$fetchOptions === void 0 ? {} : _ref2$fetchOptions,
    wafHeader = _ref2.wafHeader,
    rest = _objectWithoutProperties(_ref2, ["fetchClient", "operationType", "operationName", "versionedQuery", "token", "visitId", "visitorId", "hash", "variables", "appId", "callerId", "url", "cloudStack", "method", "fetchOptions", "wafHeader"]);
  var headers = createHeaders({
    visitId: visitId,
    visitorId: visitorId,
    token: token,
    appId: appId,
    callerId: callerId,
    cloudStack: cloudStack,
    wafHeader: wafHeader
  });
  var operation = rest[operationType];
  if (!operation && !(hash || versionedQuery)) {
    throw noHashAndOperationError;
  }
  var options = {
    headers: headers,
    credentials: 'include',
    method: method || OPERATION_METHODS[operationType]
  };
  var fetchClientUrl = url;
  if (versionedQuery) {
    fetchClientUrl += "/".concat(versionedQuery);
  }
  if (options.method === 'GET') {
    // Only add query params for GETs.
    var hashParam = hash ? "hash=".concat(hash, "&") : '';
    var operationParam = operation ? "".concat(operationType, "=").concat(operation, "&") : '';
    var variablesParam = "variables=".concat(window.encodeURIComponent(JSON.stringify(variables)));
    var queryParams = "?".concat(hashParam).concat(operationParam).concat(variablesParam);
    fetchClientUrl = "".concat(fetchClientUrl).concat(queryParams);
  } else {
    var _JSON$stringify;
    options.body = JSON.stringify((_JSON$stringify = {
      hash: hash,
      variables: variables
    }, _defineProperty(_JSON$stringify, operationType, operation), _defineProperty(_JSON$stringify, "operationName", operationName), _JSON$stringify));
  }
  return fetchClient(fetchClientUrl, _objectSpread(_objectSpread({}, options), fetchOptions));
}